// Feedback only. The API resolves and pins public DNS at every network hop.

// Marketplace pages are not a website source until use is confirmed (the API
// refuses them too; MAIN-847 covers ezCater separately).
export const isMarketplaceUrl = (value) => {
  try {
    return /(^|\.)ezcater\.com$/i.test(new URL(value).hostname);
  } catch {
    return false;
  }
};

// MAIN-847: ezCater storefronts are accepted only where the import is
// enabled for this build. The API also checks the flag, the retrieval mode
// and the caterer's authorization, so this is feedback only.
export const isEzCaterImportEnabled = () =>
  process.env.REACT_APP_MENU_EZCATER_IMPORT_ENABLED === "true";

// Same rule as the API: https://www.ezcater.com/catering/<slug>.
export function isEzCaterStorefrontUrl(value) {
  try {
    const url = new URL(value);
    return (
      url.protocol === "https:" &&
      ["www.ezcater.com", "ezcater.com"].includes(url.hostname.toLowerCase()) &&
      !url.username &&
      !url.password &&
      !url.port &&
      /^\/catering\/[a-z0-9][a-z0-9-]{0,199}\/?$/i.test(url.pathname)
    );
  } catch {
    return false;
  }
}

export function isValidWebsiteMenuUrl(value, { ezCaterEnabled = isEzCaterImportEnabled() } = {}) {
  if (isMarketplaceUrl(value)) return ezCaterEnabled && isEzCaterStorefrontUrl(value);
  try {
    const url = new URL(value);
    return (
      ["http:", "https:"].includes(url.protocol) &&
      !url.username &&
      !url.password &&
      !url.port &&
      url.hostname.includes(".") &&
      !/(^|\.)(localhost|local|internal|test|invalid|example)$/.test(url.hostname) &&
      !/^(127\.|10\.|192\.168\.|169\.254\.|0\.|172\.(1[6-9]|2\d|3[01])\.)/.test(url.hostname)
    );
  } catch {
    return false;
  }
}
